import React from 'react';
import { Link } from 'react-router-dom';
import { aboutIntroduction, aboutSections } from '../data/about';
import SEOTags from '../components/SEOTags';
import BeyondWork from '../components/BeyondWork';
import Portrait from '../components/Portrait';

export default function AboutPage() {
  return <div className="portfolio-home">
    <SEOTags title="About | Anurag Kumar" description="Meet Anurag Kumar, a Mumbai-based software engineer working across backend engineering, Generative AI, applied machine learning and enterprise banking systems."/>
    <article className="portfolio-container portfolio-section about-page" aria-labelledby="about-title">
      <header className="section-heading"><div><p className="section-kicker">About</p><h1 id="about-title">Software engineering.<br/><span>Applied intelligence.</span></h1></div></header>
      <div className="about-layout"><div className="about-copy">
        <h2>About Me</h2>
        {aboutIntroduction.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
        {aboutSections.map(section => <section key={section.title}><h2>{section.title}</h2>{section.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}</section>)}
        <div className="portfolio-actions"><Link className="portfolio-button filled" to="/projects">Explore my projects</Link><Link className="portfolio-button" to="/contact">Get in touch</Link></div>
      </div><aside className="about-aside" aria-label="Professional focus"><Portrait/><p className="section-kicker">My focus</p><ul><li>Backend engineering</li><li>Generative AI</li><li>Applied machine learning</li><li>Enterprise systems</li></ul><p className="section-kicker">Based in</p><p>Mumbai, India</p><p className="section-kicker">Credentials</p><p>AWS Certified AI Practitioner</p><p>IIIT Kottayam graduate</p></aside></div>
      <BeyondWork/>
    </article>
  </div>;
}
